module.exports = __webpack_public_path__ + "static/media/body-logo.8a7cde1c.png";